export const NUMBER_OF_SEARCH_RESULTS = 4;

export const NUMBER_OF_COURSES = '5,000+';
